import styled, { css } from "styled-components";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  * {
    font-family: "Roboto";
  }

  ${({ fitWidth }: { fitWidth: boolean }) =>
    fitWidth &&
    css`
      width: 100%;
    `}

  ${({ fitHeight }) =>
    fitHeight &&
    css`
      height: 100%;
    `}

  .filepicker {
    background-color: ${COLORS.WHITE};
    border-radius: 4px;
    border: 1px dashed ${COLORS.BLACK_25};
  }

  ${({ error }) =>
    error &&
    css`
      .filepicker {
        border-color: ${COLORS.RED};
      }
    `}

  .dz-message {
    font-size: 14px;
    color: ${COLORS.BLACK_50};
  }

  .dropzone .dz-preview .dz-details .dz-filename:hover {
    display: flex;
    justify-content: center;
    white-space: normal;
  }

  .dropzone .dz-preview.dz-error .dz-error-mark {
    display: none;
  }

  .dropzone .dz-preview.dz-error .dz-error-message {
    opacity: 1;
    margin-top: 20px;
  }

  .dropzone .dz-preview .dz-image {
    border: 1px solid #999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${({ hideProgressBar }) =>
    hideProgressBar &&
    css`
      .dz-progress {
        display: none;
      }
    `}
`;
